import React, { useState } from "react"
import { graphql } from "gatsby"
import { Layout } from "../components/Layout"
import { SEO } from "../components/SEO"
import { ArticleCard } from "../components/ArticleCard"
import { AffiliateList } from "../components/AffiliateList"
import { FilterTags } from "../components/FilterTags"
import containerClasses from "../styles/container.module.css"
import glamour from "../assets/icons/glamour-black.svg"
import stylist from "../assets/icons/stylist-black.svg"
import vogue from "../assets/icons/vogue.svg"
import harpersBazaar from "../assets/icons/harpers-bazaar.svg"
import marieClaire from "../assets/icons/marie-claire.svg"
import grazia from "../assets/icons/grazia.svg"
import marksAndSpencer from "../assets/icons/marks-and-spencer-logo-black.svg"

// One beauty feature. Rendered by the desktop grid and by the mobile
// carousel, so the two can never drift apart.
const BeautyCard = ({ item }) => (
  <div className="flex flex-col h-full">
    <a
      href={item.articleOnSite || item.article}
      {...(item.articleOnSite
        ? {}
        : { target: "_blank", rel: "noopener noreferrer" })}
      className="block"
    >
      <img
        loading="lazy"
        className="object-cover w-full"
        alt={item.imageAlt}
        src={item.image}
      />
    </a>
    <div className="flex flex-col flex-grow pt-6 lg:pt-8">
      <p className="mb-3 font-mono text-xs text-gray-500 uppercase">
        {item.dateText}
      </p>
      <h2 className="mt-0 mb-5 font-serif text-2xl lg:text-2xl leading-snug">
        {item.title}
      </h2>
      <div className="flex flex-wrap gap-2 mt-auto">
        {item.articleOnSite && (
          <a
            href={item.articleOnSite}
            className="inline-block self-start whitespace-nowrap px-3 sm:px-5 py-3 bg-blackNew text-white font-mono text-xs tracking-wider uppercase no-underline"
          >
            Read on-site &rarr;
          </a>
        )}
        {item.article && (
          <a
            href={item.article}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block self-start whitespace-nowrap px-3 sm:px-5 py-3 border border-solid border-blackNew text-blackNew font-mono text-xs tracking-wider uppercase no-underline"
          >
            Read off-site &rarr;
          </a>
        )}
      </div>
    </div>
  </div>
)

const InThePress = ({ data }) => {
  const dataArr = data?.pressPosts?.edges

  const articlesDestructured = []

  dataArr?.map(article => {
    return articlesDestructured.push({
      ...article.node.frontmatter,
    })
  })

  const [articles, setArticlesState] = useState(articlesDestructured)

  const pressCategories = [
    {
      title: "Year",
      uid: "yearNumber",
    },
  ]

  const beautyFeatures = articlesDestructured.filter(
    article => article.featureInBeauty
  )
  const beautyBig = beautyFeatures[0]
  const beautySides = beautyFeatures.slice(1, 4)

  const topStoryFeatures = articlesDestructured.filter(
    article => article.topStory
  )
  // The big Featured slot is whichever story is flagged topStoryMain; with
  // nothing flagged it falls back to the most recent, which is what it always
  // used to do. The remaining top stories fill the sides.
  const topStoryBig =
    topStoryFeatures.find(article => article.topStoryMain) ||
    topStoryFeatures[0]
  const topStorySides = topStoryFeatures
    .filter(article => article !== topStoryBig)
    .slice(0, 3)

  return (
    <Layout page="In The Press">
      <SEO
        title="Miss Elizabeth Hawkes | Media & PR | In The Press"
        description="Miss Hawkes is regularly featured in media including OK!, Sloane Square Magazine, The Sunday Times and more. Read the latest."
        pathname="/in-the-press/"
      />
      {/* Top stories */}
      <div className="bg-white">
        <div className={`${containerClasses.container} pt-12 lg:pt-12`}>
          <div className="col-span-4 border-gold600 border-solid border-t-1 border-b-1 md:col-span-8 lg:col-span-12">
            <h1 className="py-4 my-0 font-sans text-2xl font-extrabold leading-none tracking-wider uppercase lg:text-3xl">
              Featured
            </h1>
          </div>
        </div>
      </div>
      {topStoryBig ? (
        <div className="bg-white">
          <div
            className={`${containerClasses.container} pt-4 pb-8 md:pt-6 md:pb-12 lg:pt-6 lg:pb-12`}
          >
            {/* First top story */}
            <div className="relative flex col-span-4 mb-6 lg:mb-0 lg:flex-grow lg:row-span-2 lg:flex lg:col-span-6">
              <div className="bg-white flex flex-col h-full w-full">
                <a
                  href={topStoryBig.articleOnSite || topStoryBig.article}
                  {...(topStoryBig.articleOnSite
                    ? {}
                    : { target: "_blank", rel: "noopener noreferrer" })}
                  className="block w-full"
                >
                  <img
                    loading="lazy"
                    className="object-cover w-full lg:max-h-56 xl:max-h-64"
                    alt={topStoryBig.imageAlt}
                    src={topStoryBig.image}
                  />
                </a>
                <div className="flex flex-col flex-grow pt-6 lg:pt-8">
                  <p className="mb-3 font-mono text-xs text-gray-500 uppercase">
                    {topStoryBig.dateText}
                  </p>
                  <h2 className="mt-0 mb-5 text-2xl font-bold leading-snug lg:text-2xl">
                    {topStoryBig.title}
                  </h2>
                  <p className="hidden mb-6 text-gray-600 lg:block">
                    {topStoryBig.excerpt}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {topStoryBig.articleOnSite && (
                      <a
                        href={topStoryBig.articleOnSite}
                        className="inline-block self-start whitespace-nowrap px-3 sm:px-5 py-3 bg-blackNew text-white font-mono text-xs tracking-wider uppercase no-underline"
                      >
                        Read on-site &rarr;
                      </a>
                    )}
                    {topStoryBig.article && (
                      <a
                        href={topStoryBig.article}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block self-start whitespace-nowrap px-3 sm:px-5 py-3 border border-solid border-blackNew text-blackNew font-mono text-xs tracking-wider uppercase no-underline"
                      >
                        Read off-site &rarr;
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Top story cards 2-4 wrapper */}
            <div className="col-span-4 grid grid-cols-2 gap-6 lg:flex lg:flex-col lg:col-span-6 lg:col-start-7 lg:row-span-2">
              {topStorySides.map((side, idx) => (
                <div
                  key={`top-side-${idx}`}
                  className={`bg-white lg:flex-1${
                    idx < topStorySides.length - 1 ? " lg:mb-4" : ""
                  }${idx === 2 ? " col-span-2 lg:col-span-1" : ""}`}
                >
                  <div className="flex flex-col h-full lg:flex-row">
                    <a
                      href={side.articleOnSite || side.article}
                      {...(side.articleOnSite
                        ? {}
                        : { target: "_blank", rel: "noopener noreferrer" })}
                      className="block w-full lg:w-1/2 lg:flex-shrink-0 lg:self-start overflow-hidden"
                      style={{ aspectRatio: "3 / 2" }}
                    >
                      <img
                        loading="lazy"
                        className="object-cover w-full h-full"
                        alt={side.imageAlt}
                        src={side.image}
                      />
                    </a>
                    <div className="flex flex-col flex-grow pt-6 pb-6 lg:p-8">
                      <p className="mt-0 mb-3 font-mono text-xs leading-none text-gray-500 uppercase">
                        {side.dateText}
                      </p>
                      <h2
                        className={`mt-0 mb-5 font-bold leading-snug lg:text-lg ${
                          idx === 2 ? "text-2xl lg:text-lg" : "text-lg"
                        }`}
                      >
                        {side.title}
                      </h2>
                      <div className="flex flex-wrap gap-2 mt-auto lg:mt-0">
                        {side.articleOnSite && (
                          <a
                            href={side.articleOnSite}
                            className="inline-block self-start whitespace-nowrap px-3 sm:px-5 py-3 bg-blackNew text-white font-mono text-xs tracking-wider uppercase no-underline"
                          >
                            Read on-site &rarr;
                          </a>
                        )}
                        {side.article && (
                          <a
                            href={side.article}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-block self-start whitespace-nowrap px-3 sm:px-5 py-3 border border-solid border-blackNew text-blackNew font-mono text-xs tracking-wider uppercase no-underline"
                          >
                            Read off-site &rarr;
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}

      {/* Beauty Features */}
      {beautyFeatures.length > 0 ? (
        <div className="py-16 md:py-24 lg:py-28">
          <div className={`${containerClasses.container}`}>
            <div className="col-span-4 border-gold600 border-solid border-t-1 border-b-1 md:col-span-8 lg:col-span-12">
              <h1 className="py-4 my-0 font-sans text-2xl font-extrabold leading-none tracking-wider uppercase lg:text-3xl">
                Beauty
              </h1>
            </div>
          </div>
          <div className={`${containerClasses.container} pt-4 md:pt-6 lg:pt-8`}>
            <p className="col-span-4 mt-0 mb-6 font-serif italic text-lg lg:text-xl leading-relaxed text-gray-500 md:col-span-8 lg:col-span-8 lg:mb-8">
              Dr Hawkes is a leading voice in the international beauty press,
              grounding beauty advancements in a deep understanding of ocular
              and skin health.
            </p>
            {/* Mobile: one card at a time with the next peeking, so the
                buttons get the full width and never wrap. Desktop keeps the
                five-across grid. */}
            <div className="col-span-4 md:col-span-8 lg:hidden snapRow">
              {beautyFeatures.slice(0, 5).map((item, idx) => (
                <div key={`beauty-m-${idx}`}>
                  <BeautyCard item={item} />
                </div>
              ))}
            </div>
            <div className="hidden lg:col-span-12 lg:grid lg:grid-cols-5 lg:gap-4">
              {beautyFeatures.slice(0, 5).map((item, idx) => (
                <div key={`beauty-${idx}`} className="block h-full">
                  <BeautyCard item={item} />
                </div>
              ))}
            </div>
            {/* Beauty press logo strip */}
            <div className="col-span-4 md:col-span-8 lg:col-span-12 mt-12 lg:mt-16 pt-10 lg:pt-12 border-t border-gray-200">
              <p className="mb-6 lg:mb-10 font-mono text-xs tracking-wider text-center text-gray-500 uppercase">
                Featured in Beauty Editorial and M&amp;S Ambassador
              </p>
              <div className="grid grid-cols-3 md:grid-cols-7 gap-6 lg:gap-10 items-center justify-items-center">
                {[
                  {
                    name: "Marks & Spencer",
                    src: marksAndSpencer,
                    maxH: "max-h-4 md:max-h-5 lg:max-h-8",
                  },
                  { name: "Harper's Bazaar", src: harpersBazaar },
                  { name: "Vogue", src: vogue },
                  { name: "Marie Claire", src: marieClaire },
                  { name: "Glamour", src: glamour },
                  { name: "Grazia", src: grazia },
                  { name: "Stylist", src: stylist },
                ].map((logo, idx) => (
                  <div
                    key={`beauty-logo-${idx}`}
                    className={`flex items-center justify-center w-full h-10 md:h-14 lg:h-16${
                      idx === 6 ? " col-span-3 md:col-span-1" : ""
                    }`}
                  >
                    {logo.src ? (
                      <img
                        loading="lazy"
                        src={logo.src}
                        alt={`${logo.name} logo`}
                        className={`${logo.maxH ||
                          "max-h-4 md:max-h-10 lg:max-h-12"} max-w-full object-contain`}
                      />
                    ) : (
                      <div className="flex items-center justify-center w-full h-full border border-dashed border-gray-300">
                        <span className="font-mono text-xs tracking-wider text-gray-400 uppercase">
                          {logo.name}
                        </span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            {/* Press quote */}
            <div className="col-span-4 md:col-span-8 lg:col-span-12 mt-10 lg:mt-14">
              <blockquote className="max-w-3xl mx-auto text-center">
                <p className="mb-5 font-serif italic text-2xl lg:text-4xl leading-snug text-gray-600">
                  &ldquo;An international reputation in&hellip;
                  <br />
                  aesthetic eye rejuvenation.&rdquo;
                </p>
                <footer
                  className="font-mono tracking-wider text-gold600 uppercase"
                  style={{ fontSize: "0.65rem" }}
                >
                  —{" "}
                  <a
                    href="https://www.marieclaireevents.uk/skinawards/speaker/1830151/elizabeth-hawkes"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="hover:text-blackNew"
                  >
                    Marie Claire
                  </a>
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      ) : null}
      <div className="bg-white">
        <div className={`${containerClasses.container} pt-12 lg:pt-12`}>
          <div className="col-span-4 border-gold600 border-solid border-t-1 border-b-1 md:col-span-8 lg:col-span-12">
            <h1 className="py-4 my-0 font-sans text-2xl font-extrabold leading-none tracking-wider uppercase lg:text-3xl">
              The Archive
            </h1>
          </div>
        </div>
      </div>
      <div className="bg-white">
        <div className={`${containerClasses.container} py-8 lg:py-8`}>
          <div className="col-span-4 pb-4 md:col-span-8 lg:col-span-3">
            <FilterTags
              types={pressCategories}
              items={articlesDestructured}
              setItemsState={setArticlesState}
            />
          </div>
          <div className="col-span-4 md:col-span-8 lg:col-span-9 lg:col-start-4">
            {articles.map((article, key) => (
              <div key={`article-${key}`} className="mb-20 lg:mb-10">
                <ArticleCard {...article} />
              </div>
            ))}
          </div>
        </div>
      </div>
      <AffiliateList />
    </Layout>
  )
}

export default InThePress

export const query = graphql`
  query {
    pressPosts: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/press/" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          frontmatter {
            id
            dateText
            yearNumber
            title
            excerpt
            image
            imageAlt
            imageTitle
            article
            articleOnSite
            podcast
            featureInBeauty
            topStory
            topStoryMain
          }
        }
      }
    }
  }
`
